import { createAction } from '@ngrx/store';

import { ACTIONS_SCOPE } from './subscription-plan-checkout-api.actions';

export const loadConfig = createAction(
	`${ ACTIONS_SCOPE } Load Config`,
);
